export default __webpack_public_path__ + "static/media/AuthImage.af71928f.png";